<template>
    <div v-if="filteredTrays.length" class="p-6">
        <h3 class="font-semibold mb-5 text-v2-gray-80 text-xs uppercase">Trays ({{ filteredTrays.length ?? 0 }})</h3>
        <div v-if="searchIsLoading" class="rounded block loading-value !w-full !h-[66px]"></div>
        <ul v-else-if="!searchIsLoading && filteredTrays?.length" class="space-y-2">
            <PinTray v-for="tray in filteredTrays" :tray="tray" />
        </ul>
        <div v-else-if="!searchIsLoading && !filteredTrays.length && searchInput.length">
            No results
        </div>
    </div>
</template>

<script setup>
import {PinTray} from "@/Components/Modules/Dialogs/Pins/Components";
import {usePinsDrawer} from "@/Composables";
import {computed} from "vue";

const { drawer, searchIsLoading } = usePinsDrawer();
const props = defineProps(['searchInput']);

const filteredTrays = computed(() => {
    let trays = drawer.value?.trays;
    if(props.searchInput?.length) {
        return trays.filter(tray => {
            return tray.name.toLowerCase().includes(props.searchInput.toLowerCase());
        })
    }
    return trays;
})
</script>
